// This file is auto-generated by @hey-api/openapi-ts

import type { DeleteOrganisationResponse, GalleyProductResponse, GalleyProductsSearchResponse, GalleyProjectCreateResponse, GalleyProjectResponse, GalleySeasonalEventsResponse, GetEvaluationResponse, GetEvaluationsListResponse, GetOrganisationResponse, GetOrganisationsResponse, GetOrganisationsUsersResponse, GetOrganisationUserApiKeysResponse, GetOrganisationUserResponse, PatchOrganisationResponse, PatchUserResponse, PostChildOrganisationResponse, PostEvaluationResponse, PostOrganisationFileRouteResponse, PostOrganisationResponse, PostOrganisationUserApiKeyResponse, PostUserResponse, ProductsSearchResponse, TransferUserOrganisationResponse, UndeleteOrganisationResponse, UpdateOrganisationSettingsResponse, V1GetProductResponse } from './types.gen';

const productSchemaResponseTransformer = (data: any) => {
    if (data.publishedAt) {
        data.publishedAt = new Date(data.publishedAt);
    }
    if (data.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

const productSearchHitSchemaResponseTransformer = (data: any) => {
    data.document = productSchemaResponseTransformer(data.document);
    return data;
};

const productSearchResponseSchemaResponseTransformer = (data: any) => {
    data.hits = data.hits.map((item: any) => productSearchHitSchemaResponseTransformer(item));
    return data;
};

const apiResponseProductSearchResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = productSearchResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const productsSearchResponseTransformer = async (data: any): Promise<ProductsSearchResponse> => {
    data = apiResponseProductSearchResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const accountOrganisationResponseSchemaResponseTransformer = (data: any) => {
    if (data.createdAt) {
        data.createdAt = new Date(data.createdAt);
    }
    if (data.deletedAt) {
        data.deletedAt = new Date(data.deletedAt);
    }
    if (data.hardDeletedAt) {
        data.hardDeletedAt = new Date(data.hardDeletedAt);
    }
    return data;
};

const accountOrganisationsResponseSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => accountOrganisationResponseSchemaResponseTransformer(item));
    }
    return data;
};

const apiResponseAccountOrganisationsResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountOrganisationsResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const getOrganisationsResponseTransformer = async (data: any): Promise<GetOrganisationsResponse> => {
    data = apiResponseAccountOrganisationsResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountOrganisationResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const deleteOrganisationResponseTransformer = async (data: any): Promise<DeleteOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const getOrganisationResponseTransformer = async (data: any): Promise<GetOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const patchOrganisationResponseTransformer = async (data: any): Promise<PatchOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const postChildOrganisationResponseTransformer = async (data: any): Promise<PostChildOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const undeleteOrganisationResponseTransformer = async (data: any): Promise<UndeleteOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const postOrganisationResponseTransformer = async (data: any): Promise<PostOrganisationResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const updateOrganisationSettingsResponseTransformer = async (data: any): Promise<UpdateOrganisationSettingsResponse> => {
    data = apiResponseAccountOrganisationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const firestoreUserApiKeySchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt);
    return data;
};

const userResponseSchemaResponseTransformer = (data: any) => {
    if (data.apiKeys) {
        data.apiKeys = data.apiKeys.map((item: any) => firestoreUserApiKeySchemaResponseTransformer(item));
    }
    if (data.deletedAt) {
        data.deletedAt = new Date(data.deletedAt);
    }
    return data;
};

const accountUsersResponseSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => userResponseSchemaResponseTransformer(item));
    }
    return data;
};

const apiResponseAccountUsersResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountUsersResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const getOrganisationsUsersResponseTransformer = async (data: any): Promise<GetOrganisationsUsersResponse> => {
    data = apiResponseAccountUsersResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const accountUserResponseSchemaResponseTransformer = (data: any) => {
    if (data.deletedAt) {
        data.deletedAt = new Date(data.deletedAt);
    }
    return data;
};

const apiResponseAccountUserResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountUserResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const postUserResponseTransformer = async (data: any): Promise<PostUserResponse> => {
    data = apiResponseAccountUserResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const getOrganisationUserResponseTransformer = async (data: any): Promise<GetOrganisationUserResponse> => {
    data = apiResponseAccountUserResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const patchUserResponseTransformer = async (data: any): Promise<PatchUserResponse> => {
    data = apiResponseAccountUserResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const transferUserOrganisationResponseTransformer = async (data: any): Promise<TransferUserOrganisationResponse> => {
    data = apiResponseAccountUserResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const accountUserApiKeysResponseSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => firestoreUserApiKeySchemaResponseTransformer(item));
    }
    return data;
};

const apiResponseAccountUserApiKeysResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountUserApiKeysResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const getOrganisationUserApiKeysResponseTransformer = async (data: any): Promise<GetOrganisationUserApiKeysResponse> => {
    data = apiResponseAccountUserApiKeysResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const accountUserApiKeyCreatedResponseSchemaResponseTransformer = (data: any) => {
    data.user_api_key = firestoreUserApiKeySchemaResponseTransformer(data.user_api_key);
    return data;
};

const apiResponseAccountUserApiKeyCreatedResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountUserApiKeyCreatedResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const postOrganisationUserApiKeyResponseTransformer = async (data: any): Promise<PostOrganisationUserApiKeyResponse> => {
    data = apiResponseAccountUserApiKeyCreatedResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const accountOrganisationFileResponseSchemaResponseTransformer = (data: any) => {
    if (data.date) {
        data.date = new Date(data.date);
    }
    return data;
};

const apiResponseAccountOrganisationFileResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = accountOrganisationFileResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const postOrganisationFileRouteResponseTransformer = async (data: any): Promise<PostOrganisationFileRouteResponse> => {
    data = apiResponseAccountOrganisationFileResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const evaluationResponseSchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt);
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

const evaluationsResponseSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => evaluationResponseSchemaResponseTransformer(item));
    return data;
};

const apiResponseEvaluationsResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = evaluationsResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const getEvaluationsListResponseTransformer = async (data: any): Promise<GetEvaluationsListResponse> => {
    data = apiResponseEvaluationsResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const apiResponseEvaluationResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = evaluationResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const postEvaluationResponseTransformer = async (data: any): Promise<PostEvaluationResponse> => {
    data = apiResponseEvaluationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

export const getEvaluationResponseTransformer = async (data: any): Promise<GetEvaluationResponse> => {
    data = apiResponseEvaluationResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const galleySearchHitSchemaResponseTransformer = (data: any) => {
    data.document = productSchemaResponseTransformer(data.document);
    return data;
};

const galleySearchResponseSchemaResponseTransformer = (data: any) => {
    data.hits = data.hits.map((item: any) => galleySearchHitSchemaResponseTransformer(item));
    return data;
};

const apiResponseGalleySearchResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = galleySearchResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const galleyProductsSearchResponseTransformer = async (data: any): Promise<GalleyProductsSearchResponse> => {
    data = apiResponseGalleySearchResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const galleyBookResponseSchemaResponseTransformer = (data: any) => {
    data.document = productSchemaResponseTransformer(data.document);
    return data;
};

const apiResponseGalleyBookResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = galleyBookResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const galleyProductResponseTransformer = async (data: any): Promise<GalleyProductResponse> => {
    data = apiResponseGalleyBookResponseStatus200SchemaResponseTransformer(data);
    return data;
};

const galleySeasonalEventSchemaResponseTransformer = (data: any) => {
    data.start = new Date(data.start);
    data.end = new Date(data.end);
    data.planning_starts = new Date(data.planning_starts);
    return data;
};

const galleySeasonalEventListSchemaResponseTransformer = (data: any) => {
    data.window_start = new Date(data.window_start);
    data.window_end = new Date(data.window_end);
    data.events = data.events.map((item: any) => galleySeasonalEventSchemaResponseTransformer(item));
    return data;
};

const apiResponseGalleySeasonalEventListStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = galleySeasonalEventListSchemaResponseTransformer(data.data);
    }
    return data;
};

export const galleySeasonalEventsResponseTransformer = async (data: any): Promise<GalleySeasonalEventsResponse> => {
    data = apiResponseGalleySeasonalEventListStatus200SchemaResponseTransformer(data);
    return data;
};

const galleyProjectBookSchemaResponseTransformer = (data: any) => {
    if (data.published_at) {
        data.published_at = new Date(data.published_at);
    }
    return data;
};

const galleyProjectSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.books = data.books.map((item: any) => galleyProjectBookSchemaResponseTransformer(item));
    return data;
};

const apiResponseGalleyProjectStatus201SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = galleyProjectSchemaResponseTransformer(data.data);
    }
    return data;
};

export const galleyProjectCreateResponseTransformer = async (data: any): Promise<GalleyProjectCreateResponse> => {
    data = apiResponseGalleyProjectStatus201SchemaResponseTransformer(data);
    return data;
};

const apiResponseGalleyProjectStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = galleyProjectSchemaResponseTransformer(data.data);
    }
    return data;
};

export const galleyProjectResponseTransformer = async (data: any): Promise<GalleyProjectResponse> => {
    data = apiResponseGalleyProjectStatus200SchemaResponseTransformer(data);
    return data;
};

const firestoreProductCategorizationSchemaResponseTransformer = (data: any) => {
    if (data.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

const firestoreProductManuscriptAnalysisSchemaResponseTransformer = (data: any) => {
    if (data.generatedAt) {
        data.generatedAt = new Date(data.generatedAt);
    }
    return data;
};

const firestoreProductManuscriptSchemaResponseTransformer = (data: any) => {
    data.uploadedAt = new Date(data.uploadedAt);
    if (data.analysis) {
        data.analysis = firestoreProductManuscriptAnalysisSchemaResponseTransformer(data.analysis);
    }
    return data;
};

const productResponseSchemaResponseTransformer = (data: any) => {
    if (data.publishedAt) {
        data.publishedAt = new Date(data.publishedAt);
    }
    data.createdAt = new Date(data.createdAt);
    data.updatedAt = new Date(data.updatedAt);
    if (data.forceSyncTriggeredAt) {
        data.forceSyncTriggeredAt = new Date(data.forceSyncTriggeredAt);
    }
    if (data.categorization) {
        data.categorization = firestoreProductCategorizationSchemaResponseTransformer(data.categorization);
    }
    if (data.manuscript) {
        data.manuscript = firestoreProductManuscriptSchemaResponseTransformer(data.manuscript);
    }
    return data;
};

const apiResponseProductResponseStatus200SchemaResponseTransformer = (data: any) => {
    if (data.data) {
        data.data = productResponseSchemaResponseTransformer(data.data);
    }
    return data;
};

export const v1GetProductResponseTransformer = async (data: any): Promise<V1GetProductResponse> => {
    data = apiResponseProductResponseStatus200SchemaResponseTransformer(data);
    return data;
};
